// frontend/src/components/Footer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-light py-4">
      <Container>
        <Row>
          <Col md={6}>
            <p>&copy; {new Date().getFullYear()} RxRooster. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-md-right">
            <a href="https://www.facebook.com/profile.php?id=61571625713755" target="_blank" rel="noopener noreferrer" className="text-dark mx-2">
              <FaFacebook size={24} />
            </a>
            <a href="https://x.com/RxRooster" target="_blank" rel="noopener noreferrer" className="text-dark mx-2">
              <FaTwitter size={24} />
            </a>
            <a href="https://www.linkedin.com/company/rx-rooster/" target="_blank" rel="noopener noreferrer" className="text-dark mx-2">
              <FaLinkedin size={24} />
            </a>
            <a href="https://www.linkedin.com/company/rx-rooster/" target="_blank" rel="noopener noreferrer" className="text-dark mx-2">
              <FaInstagram size={24} />
            </a>
          </Col>
        </Row>
        <Row> 
          <Col md={12}>
            <Link to="/privacy-policy">Privacy Policy</Link> |{' '}
          </Col>
          <Col md={12}>
            <Link to="/terms-of-service">Terms of Service</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
